<template>
    <div class="school">
        <div class="school-title">商学院</div>
        <div class="school-count">
            <div class="school-count-top">
                <div class="school-count-top-l"></div>
                <div class="school-count-top-r">{{ shareData.clerkName }}</div>
                <div class="school-count-top-head">
                    <div class="head-img" :style="'background: url(' +  shareData.clerkAvatar + ') no-repeat; background-size: cover;'"></div>
                </div>
            </div>
            <div class="school-count-body">
                <img class="body-l" :src="shareData.coverImage" alt="">
                <div class="body-r">{{ shareData.name }}</div>
            </div>
            <div v-if="isWX" style="margin: 16px auto 0 auto; width: 246px;">
                <template v-if="isWX">
                    <wx-open-launch-app
                        id="jump-app"
                        appid="wxcf26e67f34abb5e5"
                        :extinfo="extinfo"
                    >  
                        <div v-is="'script'" type="text/wxtag-template">
                            <div style="
                                width: 246px;
                                background: #0F50C5 !important;
                                border-radius: 8px; 
                                line-height: 40px; 
                                margin: auto;
                                color: #fff;
                                font-size: 14px;
                                text-align: center;"
                            >立即学习</div>
                        </div>
                    </wx-open-launch-app>
                </template>
            </div>
            <div v-else class="school-count-btn" @click="immediateStudy">立即学习</div>
        </div>
    </div>
</template>

<script>
import { getUrlKey } from '@/utils/util'
import { isWeChat } from '@/utils/validate';
export default {
    // 商学院
    name: 'BusinessSchool',
    data() {
        return {
            shareData: {},
            isWX: false,
            extinfo: '',
            appId: ''
        }
    },
    created() {
        this.isWX = isWeChat()
        
    },
    mounted() {
        this.getShare()
    },
    methods: {
        // 获取课程信息/course/share
        submitDelete() {
            this.$dialog.confirm({
                message: '请点击页面右上角". . ."选择“在浏览器打开”',
                confirmButtonColor: "#0F50C5",
                cancelButtonColor: "#000000"
            });
        },
        getShare() {
            let time = this.$toast.loading('加载中...')
            this.$http.post('/h5/course/share',{
                code: getUrlKey('code')
            }).then(({ data: res }) => {
                time.close()
                if(res.success) {
                    this.shareData = res.data
                    this.extinfo = res.data.path
                    if(isWeChat()) {
                        this.wxConfiguration()
                    }
                } else {
                    this.$toast.fail(res.errorMessage);
                }
            })
        },
        immediateStudy() {
            let isWe = isWeChat()
            if(isWe) {
                this.submitDelete()
                return
            }
            let time = this.$toast.loading('加载中...')
            let u = navigator.userAgent
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1 //android终端或者uc浏览器
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            this.$http.post('/h5/jump_app').then(({ data: res }) => {
                time.close()
                if(!res.success) {
                    this.$toast.fail(res.errorMessage);
                    return
                }
                if(isAndroid) {
                    let _clickTime = new Date().getTime()
                    let _count = 0, intHandle = null
                    let src = 'android://jxyy/splash?appPageRouter=' + this.shareData.path
                    window.location.href = src  // 安卓对应的app协议
                    intHandle = setInterval(function(){
                        _count++
                        let elsTime = new Date().getTime() - _clickTime;
                        if (_count >= 100 || elsTime > 3000 ) {
                            clearInterval(intHandle);
                            let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                            if (hidden) {
                                window.close()
                            } else {
                                window.location.href = res.data.androidLink
                            }
                        }
                    }, 20)
                } else if(isiOS) {
                    let _clickTime = +(new Date());
                    let src = 'jxyyService://school?appPageRouter=' + this.shareData.path
                    // window.location.href = src
                    window.location.href = src
                    let _count = 0, intHandle = null;
                    intHandle = setInterval(function(){
                        _count++
                        let elsTime =  +(new Date()) - _clickTime
                        if (_count >= 100 || elsTime > 3000 ) {
                            clearInterval(intHandle);
                            let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                            if (hidden) {
                                setTimeout(window.close, 301)
                            } else {
                                window.location.href = res.data.iosLink
                            }
                        }
                    }, 20)
                } else {
                    window.location.href = res.data.androidLink
                }
            })
        },
        wxConfiguration() {
            const url = window.location.href.split('#')[0];
            //url = encodeURIComponent(url);
            let data = {
                uri: url
            }
            this.$http.post('/h5/jssdk', data).then(({ data: res })  => {
                if(res.success) {
                    let config = res.data
                    // this.appId = config.app_id
                    // process.env.NODE_ENV == 'production' ? false : 
                    window.wx.config({
                        debug: process.env.NODE_ENV == 'production' ? false : true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: config.app_id, // 必填，企业号的唯一标识，此处填写企业号corpid
                        timestamp: Number(config.timestamp), // 必填，生成签名的时间戳
                        nonceStr: config.nonce_str, // 必填，生成签名的随机串
                        signature: config.signature, // 必填，签名
                        jsApiList: [], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        openTagList: ['wx-open-launch-app']
                    })
                    window.wx.ready((res) => {
                        var btn = document.getElementById('jump-app')
                        btn.addEventListener('error', (e) => {
                            if(e.detail.errMsg == 'launch:fail') {
                                this.submitDelete()
                            }
                        })
                    })
                    window.wx.error((res) =>{
                        this.submitDelete()
                        // this.$toast.fail(e.detail.errMsg);
                    })
                    var btn = document.getElementById('jump-app')
                    btn.addEventListener('launch', () => {
                        console.log('success');
                    });
                    btn.addEventListener('error', (e) => {
                        console.log('fail', e.detail);
                    });
                }
            })
        },
    },
}
</script>

<style lang="scss" src="./index.scss"></style>